import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import Cfg from '../configuration.vue'

import BankRepository from '@/shared/http/repositories/configuration/bank'
import BankModel from '@/shared/models/configuration/bankmodel'
import BankForms from './bank-form'

export default {
  name: 'Bank',
  mixins: [ActionsForm],
  data () {
    return {
      data: BankModel,
      form: BankForms
    }
  },
  components: {
    Cfg
  },
  computed: {
    FieldSizeTip: function () {
      return this.$lang.Common.Tips.MaximumSize.replace('@SIZE@', this.form.description.maxlength)
    }
  },
  methods: {
    onLoad () {
      loading.push()
      BankRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onCreate () {
      loading.push()
      BankRepository.Create(this.data)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onUpdate () {
      loading.push()
      BankRepository.Update(this.data)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onDelete (obj) {
      loading.push()
      BankRepository.Delete(obj.id)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configuration/bank/bank.js